const V2_TO_V6 = {
    NONE: 'none',
    API_KEY: 'apiKey',
    AWS_IAM: 'iam',
    AMAZON_COGNITO_USER_POOLS: 'userPool',
    OPENID_CONNECT: 'oidc',
    AWS_LAMBDA: 'lambda'
};

export const AUTH_TYPE = {
    NONE: 'NONE',
    API_KEY: 'API_KEY',
    AWS_IAM: 'AWS_IAM',
    AMAZON_COGNITO_USER_POOLS: 'AMAZON_COGNITO_USER_POOLS',
    OPENID_CONNECT: 'OPENID_CONNECT',
    AWS_LAMBDA: 'AWS_LAMBDA'
};

export const mapAuthMode = mode => {
    if (!mode) {
        return undefined;
    }
    const mapped = V2_TO_V6[mode];
    if (!mapped) {
        console.warn(`[amplify] unknown authMode "${mode}" - passing through unchanged`);
        return mode;
    }
    return mapped;
};

export default { AUTH_TYPE, mapAuthMode };
